export const OFFSET = 30;
export const CARDS_PER_PAGE = 12;

export const MENS = "mens";
export const WOMENS = "womens";
